import { render, staticRenderFns } from "./PropertyDetailsPage.vue?vue&type=template&id=1988bfa8&"
import script from "./PropertyDetailsPage.vue?vue&type=script&lang=js&"
export * from "./PropertyDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports